import React from 'react';
import {MainMenuBackground, UIType} from "../../ui/@const";

type Props = {
    className?              : string
    style?                  : any
    icon?                   : string
    iconComponent?          : React.ReactNode
    label?                  : string | null
    isSelected?             : boolean
    dndPreview?             : boolean
    dndIsDragged?           : boolean
    dndIsDragInProgress?    : boolean
    isMouseEntered?         : boolean
    inMorePopover?          : boolean

    showContextMenu?        : callback
    onClick?                : callback
    children?               : any
}

// const debug = "Navigation_BaseButton"
const debug = false

export default function Navigation_BaseButton(props: Props) {

    switch (gd.ui.type) {
        case UIType.TEAMS:
        case UIType.CLICK_UP:
        case UIType.ASANA: {

            const classes = Classes('ui5-navigation-btn', props.className, {
                'selected'      : props.isSelected && !props.inMorePopover,
                'is-dragged'    : props.dndIsDragged,
                'is-hover'      : !props.dndIsDragInProgress && props.isMouseEntered,
                'is-preview'    : props.dndPreview
            })

            const labelStyle : React.CSSProperties = {
                width: "80%", textAlign: "center", fontSize: 10
            }

            const labelClasses = Classes("navigation-btn-label", "ui5-txt-not-important-micro", "m-t-8", "txt-truncate", {
                "icon-color-selected": props.isSelected || props.isMouseEntered,
            })


            return (
                <div className      = {classes}
                     style          = {props.style}
                     onClick        = {props.onClick}
                     onContextMenu  = {props.showContextMenu}>

                    <div className={Classes(!props.iconComponent && props.icon, "ui5-navigation-btn-icon")}>
                        {props.iconComponent ?? null}
                        {props.children}
                    </div>

                    {!props.inMorePopover && props.label && props.label?.length > 0 && (
                        <div className={labelClasses} style={labelStyle}>
                            {props.label}
                        </div>
                    )}
                </div>
            )
        }

        case UIType.GOODDAY_MODERN:
        case UIType.LEFT:
        case UIType.TOP:
        default:
            const gooddayClasses = Classes('ui5-navigation-btn', props.className, {
                // selected        : isSelected && !props.inMorePopover,
                'selected'      : props.isSelected && !props.inMorePopover,
                'pale-bg'       : gd.session.me.settings.skin.menu === MainMenuBackground.PALE,
                'gray-bg'       : gd.session.me.settings.skin.menu === MainMenuBackground.GRAY,
                'white-bg'      : gd.session.me.settings.skin.menu === MainMenuBackground.WHITE,
                'dark-bg'       : gd.session.me.settings.skin.menu === MainMenuBackground.DARK,
                'is-dragged'    : props.dndIsDragged,
                'is-hover'      : !props.dndIsDragInProgress && props.isMouseEntered,
                'is-preview'    : props.dndPreview
            })

            // style is required for ReorderList (pointer-events: none)
            return (
                <div className      = {gooddayClasses}
                     style          = {props.style}
                     onClick        = {props.onClick}
                     onContextMenu  = {props.showContextMenu}>

                    <div className={Classes(!props.iconComponent && props.icon, "ui5-navigation-btn-icon")}>
                        {props.iconComponent ?? null}
                        {props.children}
                    </div>

                    {gd.ui.type === UIType.GOODDAY_MODERN && gd.user.settings.skin.showNavbarLabels && props.label && props.label?.length > 0 && (
                        <div className="navigation-btn-label ui5-txt-not-important-micro txt-truncate m-t-5">
                            {props.label}
                        </div>
                    )}

                    {!props.inMorePopover && (
                        <div className="right-border">
                            <svg className="top" width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8 2C8 3.65685 6.65685 5 5 5H8V2Z" className="corner"/>
                            </svg>

                            <svg className="bottom" width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8 3C8 1.34315 6.65685 0 5 0H8V3Z" className="corner"/>
                            </svg>
                        </div>
                    )}
                </div>
            )
    }
}
